import React from "react";
import { SmartForm} from './SmartForm'

export function Login() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^(?:[a-zA-Z0-9_]{3,16}|[^\s@]+@[^\s@]+\.[^\s@]+)$/, ///^[a-zA-Z0-9_]{3,16}$/
			exclusiveWith: ["wallet"]
		},
		{
			label: "Password",
			name: "password",
			type: "text",
		},
		{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username","password","mode"]
		},
		{
			name: "mode",
			value: "username",
			type: "hidden",
		},
		{
			label: "Game",
			name: "game",
			type: "select",
			options: [
			  { label: "Gem Miner", value: "1" },
			  { label: "Crypto Slash", value: "2" },
			  { label: "Moonshot", value: "3" },
			  { label: "Solitaire", value: "Solitaire" },
			  { label: "Coin Catcher", value: "5" },
			  { label: "Gem Fighter", value: "6" },
			  { label: "Frontend", value: "8" },
			  { label: "GemViewer", value: "9" },
			],
		},
		{
			label: "Version",
			name: "version",
			value: "0.0.0",
			type: "text",
		}

	];
	const defaultJson = JSON.stringify({
		info: "Login to a game or frontend, 2 modes of login exist: version 1 is with username/password the second one is with walletaddress AFTER wallet connect is performed.",
		username: "Can be the actual username HODLER #1234 or the registered email address user@mymail.com",
		wallet: "is the BSC wallet address after a wallet connect is executed. This is NOT an exposed field with manual inpit to the enduser"
	  }, null, 2);

	const depreciationNotice = [
		{
		  date: "est. 2026-01-01",
		  text: "query result will be moved into details\nresult.username, result.wallet, result userid, result.maintenance, result.allowedVersion, result.user are to be extracted from the content within result.details"
		},
	  ];
	const endpoint = {
		"human" : "Login User",
		"type" : "POST",
		"url" : "/game/login",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} defaultJson={defaultJson} depreciationNotice={depreciationNotice}/>
	);

}


export function SubmitScore() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
			exclusiveWith: ["wallet"]
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
		{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username","password"]
		},
		{
			label: "Game",
			name: "game",
			type: "select",
			options: [
			  { label: "Gem Miner", value: "1" },
			  { label: "Crypto Slash", value: "2" },
			  { label: "Moonshot", value: "3" },
			  { label: "Solitaire", value: "Solitaire" },
			  { label: "Coin Catcher", value: "5" },
			  { label: "Gem Fighter", value: "6" },
			  { label: "Frontend", value: "8" },
			  { label: "GemViewer", value: "9" },
			],
		},
		{
			label: "Score",
			name: "score",
			type: "text",
		},
		{
			label: "Difficulty",
			name: "difficulty",
			type: "select",
			options: [
			  { label: "free", value: "1" },
			  { label: "easy", value: "2" }
			],
		  },
  		{
			label: "Version",
			name: "version",
			value: "0.0.0",
			type: "text",
		}

		
	];
	  const endpoint = {
		"human" : "Submit score",
		"type" : "POST",
		"url" : "/game/score",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}


export function ChangeUser() {
	const fields = [
		{
		label: "Username",
		name: "username",
		type: "text",
		exclusiveWith: ["wallet"]
		},
		{
		label: "Password",
		name: "password",
		type: "text",
		},
		{
		label: "Wallet",
		name: "wallet",
		type: "select",
		options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		],
		regex: /^0x[a-fA-F0-9]{4,}$/,
		exclusiveWith: ["username","password"]
		},
		{
		label: "new Username",
		name: "new_username",
		type: "text",
		},
			
	];
	  const endpoint = {
		"human" : "Change Username",
		"type" : "POST",
		"url" : "/game/username",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}export function GenerateSeason() {
	const getNextMonths = () => {
		const today = new Date();
		const dates = [];
	  
		for (let i = 0; i < 5; i++) {
		  const year = today.getFullYear();
		  const month = today.getMonth() + i;
		  const date = new Date(year, month, 10);
		  const label = date.toLocaleDateString("en-GB", {
			month: "short",
			year: "numeric"
		  });
		  const value = date.toISOString().split("T")[0]; // YYYY-MM-DD
		  dates.push({ label, value });
		}
		return dates;
	  };
	
	const fields = [
		{
			label: "Select month",
			name: "month",
			type: "select",
			options: getNextMonths()
	    },
	];
	  const endpoint = {
		"human" : "Generate Seasons like last month",
		"type" : "POST",
		"url" : "/game/generateseason",
	};
	
	const defaultJson = JSON.stringify({
		info: "Provide a date for which month you want to generate the seasons. It will use the previous month season to copy. If you do not provide a date it will assume today's date.",
	  }, null, 2);
	

	return (
		<SmartForm fields={fields} endpoint = {endpoint} defaultJson={defaultJson}/>
	);

}

